<template>
    <div class="about-container">
        <SuperAdminSchoolHead>
            <template v-slot:center><span style="font-weight: 600; font-size: 22px">{{ $t('aboutSchool') }}</span></template>
        </SuperAdminSchoolHead>

        <v-card class="scl-ad_scl-info">
            <v-card-text>
                <div style="display: flex; flex-direction: row; flex-wrap: nowrap; gap: 12px; justify-content: space-between; align-items: flex-start">
                    <div class="scl-ad_scl-info_block">
                        <div class="scl-ad_scl-info_block_label">{{$t('fullTitle')}}</div>
                        <div class="scl-ad_scl-info_block_txt">{{schoolObj.nameRu}}</div>
                    </div>
                </div>
                <div class="scl-ad_scl-info_sc-block">
                    <div class="scl-ad_scl-info_block">
                        <div class="scl-ad_scl-info_block_label">{{$t('schoolOcpoCode')}}</div>
                        <div class="scl-ad_scl-info_block_txt">{{schoolObj.code}}</div>
                    </div>
                    <div class="scl-ad_scl-info_block">
                        <div class="scl-ad_scl-info_block_label">{{$t('chronicleYear')}}</div>
                        <div class="scl-ad_scl-info_block_txt">{{title}}</div>
                    </div>
                    <div class="scl-ad_scl-info_block">
                        <div class="scl-ad_scl-info_block_label">{{$t('quarter')}}</div>
                        <div class="scl-ad_scl-info_block_txt">{{titleSemester}}</div>
                    </div>
                </div>
                <div class="scl-ad_scl-info_sc-block">
                    <v-text-field :label="$t('phone')" v-model="schoolObj.phone" disabled
                                  mask="0(111)111111" placeholder="0(555)123456" outlined dense/>
                    <v-text-field label="Email" v-model="schoolObj.email" :rules="emailRules" outlined dense disabled/>
                </div>
                <div>
                    <v-select v-model="titleText" :items="schoolTypes" item-text="text" item-value="value"
                              :rules="required" :label="$t('organizationType')" outlined dense disabled/>
                    <v-select :rules="required" :items="allRegions" item-text="title" item-value="id" outlined dense disabled
                              :label="$t('region')" v-model="schoolObj.regionId" @change="fetchRayons"/>
                    <v-select :rules="required" :items="allRayons" item-text="title" item-value="id" outlined dense disabled
                              :label="$t('district')" v-model="titleRayons"/>
                </div>
            </v-card-text>
        </v-card>

<!--        <div class="school-info">-->
<!--            <div>-->
<!--                <v-text-field v-model="schoolObj.nameRu" :rules="required" :label="$t('fullTitle')" readonly/>-->
<!--            </div>-->
<!--            <div style="display: flex; flex-direction: row; flex-wrap: nowrap; gap: 4px">-->
<!--                <v-text-field v-model="schoolObj.code" :rules="required" :label="$t('schoolOcpoCode')"-->
<!--                              readonly="readonly"/>-->
<!--                <v-select :rules="required" :items="schoolQuarters" item-text="semester" item-value="id"-->
<!--                          :label="$t('quarter')" v-model="schoolObj.quarterId" readonly/>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div>&ndash;&gt;-->
<!--&lt;!&ndash;                <v-text-field v-model="schoolObj.code" :rules="required" :label="$t('schoolOcpoCode')" type="number" readonly/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div>&ndash;&gt;-->
<!--&lt;!&ndash;              <v-select :rules="required" :items="schoolQuarters" item-text="semester" item-value="id"&ndash;&gt;-->
<!--&lt;!&ndash;                        :label="$t('quarter')" v-model="schoolObj.quarterId" readonly/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div style="display: flex; flex-direction: row; flex-wrap: nowrap; gap: 4px">-->
<!--                <v-text-field :label="$t('phone')" v-model="schoolObj.phone" readonly="readonly"-->
<!--                              mask="0(111)111111" placeholder="0(555)123456"/>-->
<!--                <v-text-field label="Email" v-model="schoolObj.email" :rules="emailRules" readonly="readonly"/>-->
<!--            </div>-->
<!--&lt;!&ndash;            <div class="spacer">&ndash;&gt;-->
<!--&lt;!&ndash;                <v-text-field v-model="schoolObj.phone" :label="$t('phoneNumber')" type="number" readonly/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div>&ndash;&gt;-->
<!--&lt;!&ndash;                <v-text-field :label="$t('email')" v-model="schoolObj.email" :rules="emailRules" readonly/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--            <div>-->
<!--              <v-select :rules="required" :items="schoolTypes" item-text="text" item-value="value"-->
<!--                        :label="$t('organizationType')" v-model="schoolObj.schoolType" readonly/>-->
<!--            </div>-->
<!--            <div>-->
<!--              <v-select :rules="required" :items="allRegions" item-text="title" item-value="id"-->
<!--                        :label="$t('region')" v-model="schoolObj.regionId" @change="fetchRayons" readonly/>-->
<!--            </div>-->
<!--            <div>-->
<!--              <v-select :rules="required" :items="allRayons" item-text="title" item-value="id"-->
<!--                        :label="$t('district')" v-model="schoolObj.rayonId" readonly/>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import { RegionService } from '@/_services/region.service'
import { RayonService } from '@/_services/rayon.service'
import { QuarterService } from '@/_services/quarter.service'
import { SchoolService } from '@/_services/school.service'
import { ChronicleService } from '@/_services/chronicle.service'
const regionService = new RegionService()
const rayonService = new RayonService()
const quarterService = new QuarterService()
const schoolService = new SchoolService()
const chronicleService = new ChronicleService()

export default {
  name: 'AboutSchool',
  components: {
    SuperAdminSchoolHead
  },

  data () {
    return {
      titleText: null,
      titleRegions: null,
      titleRayons: null,
      required: [v => !!v || this.$t('required')],
      emailRules: [v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('emailMustBeValid')],
      schoolObj: {
        code: '',
        address: '',
        avatar: '',
        chronicleYearId: 0,
        description: '',
        email: '',
        languageId: 0,
        nameRu: '',
        phone: '',
        rayonId: 0,
        schoolType: '',
        quarterId: ''
      },
      allRegions: [],
      allRayons: [],
      schoolQuarters: [],
      chronicleYearList: [],
      schoolTypes: [
        { value: 'PRIVATE', text: 'Частная' },
        { value: 'STATE', text: 'Государственная' },
        { value: 'OTHER', text: 'Другое' },
        { value: 'MUNICIPALITY', text: 'Муниципальный' }
      ]
    }
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    title () {
      return this.chronicleYearList?.find(c => c.id === this.schoolObj?.chronicleYearId)?.selectorTitle ?? ''
    },
    titleSemester () {
      return this.schoolQuarters?.find(s => s.id === this.schoolObj?.quarterId)?.semester ?? ''
    }
  },

  created () {
    this.fetchRegions()
    this.fetchRayons()
    this.getQuartersBySchool()
    this.getRayonById()
    this.fetchChronicleYearList()
  },

  mounted () {
    this.schoolObj.code = this.school.code
    this.schoolObj.languageId = this.school.languageId
    this.schoolObj.chronicleYearId = this.school.chronicleId
    this.schoolObj.chronicleId = this.school.chronicleId
    this.schoolObj.nameRu = this.school.nameRu
    this.schoolObj.quarterId = this.school.quarterId
    this.schoolObj.phone = this.school.phone
    this.schoolObj.email = this.school.email
    this.schoolObj.schoolType = this.school.schoolType
    this.schoolObj.rayonId = this.school.rayonId
    this.schoolObj.pin = this.school.pin
    this.schoolObj.id = this.school.id
    this.titleRegions = this.allRegions?.find(r => r.id === this.schoolObj?.regionId) ?? ''
    this.titleText = this.schoolTypes?.find(s => s.value === this.schoolObj?.schoolType) ?? ''
  },

  methods: {
    getQuartersBySchool () {
      quarterService.getBySchoolAndChronicle(this.school.id, this.school.chronicleId).then((res) => {
        this.schoolQuarters = res.sort((a, b) => a.semester - b.semester)
      }).catch((err) => this.$toast.error(err.message))
    },

    fetchRegions () {
      regionService.list(0).then(res => {
        this.allRegions = res.content
      }).catch(err => console.log(err))
    },

    fetchRayons (id) {
      if (id) {
        rayonService.listByRegion(id).then(res => {
          this.allRayons = res
          if (this.schoolObj.rayonId) {
            this.titleRayons = this.allRayons?.find(r => r.id === this.schoolObj?.rayonId) ?? ''
          }
        }).catch(err => console.log(err))
      }
    },

    getRayonById () {
      rayonService.getById(this.school.rayonId).then((res) => {
        this.fetchRayons(res.region.id)
        this.schoolObj.regionId = res.region.id
      })
    },

    fetchChronicleYearList () {
      chronicleService.list().then((res) => {
        this.chronicleYearList = res
      }).catch((err) => this.$toast.error(err.message))
    },

    updateSchoolInfo () {
      this.userProfile.schools[0] = this.schoolObj
      schoolService.update(this.schoolObj).then(() => {
        this.$toast.success(this.$t('success'))
        this.$store.dispatch('account/updateProfileData', this.userProfile)
      }).catch((err) => {
        this.$toast.error(err)
      })
    }
  }
}
</script>

<style lang="scss">
    .about-container {
        width: 65%;
        margin: 0 auto 50px;

        .school-info {
            background: #fff;
            padding: 15px;
            border: 2px solid #03A9F4;

            .form-footer {
                text-align: center;
                button {
                    margin-right: 15px;
                }
            }
        }
    }
</style>
